import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsMuteAllTitle = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-mute-all-title", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltNotificationsPanelSettingsMuteAllTitle;
